import React from "react";

import { SimpleGrid } from "@chakra-ui/react";
import GalleryCarousal from "./GalleryCarousal";
import VideoCarousal from "./VideoCarousal";

const GallaryAndVideo = () => {
  return (
    <div id="gallery-home">
      <div className="container">
        <SimpleGrid 
        columns={[1, 2, 2, 2]}
        // columns={1}
        >
          {/* <GalleryThree /> */}
          {/* <GallerySection /> */}
          {/* hidden as per model code of conduct */}
          <GalleryCarousal />

          <VideoCarousal />
        </SimpleGrid>
      </div>
    </div>
  );
};

export default GallaryAndVideo;